/**
 * Must match `Quizter.Domain.AchievementCriteriaType` (stable SNAKE_CASE API values).
 * Order: solo/progress, tag-based, PvP.
 */
export const ACHIEVEMENT_CRITERIA_TYPES = [
  'FIRST_QUIZ_COMPLETED',
  'TOTAL_QUIZZES_COMPLETED',
  'TOTAL_QUIZZES_COMPLETED_WHILE_VIP',
  'STREAK_PERFECT_QUIZZES',
  'QUIZ_COMPLETED_UNDER_TIME',
  'USER_LEVEL_REACHED',
  'TOTAL_XP_ACCUMULATED',
  'FRIENDS_COUNT_REACHED',
  'ACCOUNT_AGE_DAYS',
  'UNIQUE_CORRECT_ANSWERS_BY_TAG',
  'TOTAL_CORRECT_ANSWERS_BY_TAG',
  'QUIZ_COMPLETED_BY_TAG',
  'PERFECT_QUIZ_BY_TAG',
  'PVP_MATCHES_WON',
  'PVP_MATCHES_PLAYED',
  'PVP_WIN_STREAK',
] as const;

export type AchievementCriteriaTypeValue = (typeof ACHIEVEMENT_CRITERIA_TYPES)[number];

/** Catalog hint: total correct answers for questions sharing a tag. */
export const CRITERIA_TOTAL_CORRECT_ANSWERS_BY_TAG: AchievementCriteriaTypeValue =
  'TOTAL_CORRECT_ANSWERS_BY_TAG';

export function isKnownAchievementCriteriaType(value: string): boolean {
  return (ACHIEVEMENT_CRITERIA_TYPES as readonly string[]).includes(value);
}
